<section class="footer-area">
    <div class="container">
        <div class="row justify-content-center">
            <div class="col-lg-4 col-md-6 col-sm-6">
                <!-- Single footer widget -->
                <div class="single-footer-widget" *ngIf="!loadingData">
                    <img src="assets/img/school/logo.png" alt="">
                    <!-- Footer widget description -->
                    <p style="color: white; padding-top: 20px;">A Bangladesh Army patronized specialized organization
                        that
                        values the holistic development of all children with special
                        educational needs through multidimensional programs.</p>
                </div>
                <div class="single-footer-widget placeholder-glow" *ngIf="loadingData">
                    <span class="placeholder col-12" style="width: 150px; height: 50px; display: block; margin-bottom: 20px;"></span>
                    <p>
                        <span class="placeholder col-12"></span>
                        <span class="placeholder col-11"></span>
                        <span class="placeholder col-12"></span>
                        <span class="placeholder col-9"></span>
                    </p>
                </div>
            </div>
            <div class="col-lg-4 col-md-6 col-sm-6">
                <!-- Single footer widget -->
                <div class="single-footer-widget pl-5" *ngIf="!loadingData">
                    <h3>Youtube</h3>
                    <div class="youtube-embed">
                        <iframe width="420" height="315" src="https://www.youtube.com/embed/ekzAmAQ_wMc" frameborder="0"
                            allowfullscreen=""></iframe>
                    </div>
                </div>
                <div class="single-footer-widget pl-5 placeholder-glow" *ngIf="loadingData">
                    <h3 class="placeholder col-6"></h3>
                    <span class="placeholder col-12" style="height: 315px; width: 420px; display: block;"></span>
                </div>
            </div>
            <div class="col-lg-4 col-md-6 col-sm-6">
                <!-- Single footer widget -->
                <div class="single-footer-widget pl-5" *ngIf="!loadingData">
                    <h3>Facebook</h3>
                    <iframe
                        src="https://www.facebook.com/plugins/page.php?href=https%3A%2F%2Fwww.facebook.com%2FProyashctg%2F&tabs&width=340&height=130&small_header=false&adapt_container_width=false&hide_cover=false&show_facepile=false&appId"
                        width="340" height="130" style="border:none;overflow:hidden" scrolling="no" frameborder="0"
                        allowfullscreen="true"
                        allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"></iframe>
                </div>
                <div class="single-footer-widget pl-5 placeholder-glow" *ngIf="loadingData">
                    <h3 class="placeholder col-6"></h3>
                    <span class="placeholder col-12" style="height: 130px; width: 340px; display: block;"></span>
                </div>
            </div>
        </div>
        <div class="copyright-area">
            <div class="row align-items-center">
                <div class="col-lg-6 col-sm-6 col-md-6">
                    <!-- Copyright notice -->
                    <p *ngIf="siteAuthor != null" [innerHTML]="siteAuthor"></p>
                </div>
                <!-- <div class="col-lg-6 col-sm-6 col-md-6">
                    <ul>
                        <li>
                            <p>Developed by <a href="https://deshuniversal.com/" class="text-gray-600 ml-1"
                                    target="_blank" rel="noopener noreferrer">Desh
                                    Universal Pvt. Limited</a></p>
                        </li>
                    </ul>
                </div> -->
            </div>
        </div>
    </div>
</section>